// extracted by mini-css-extract-plugin
export default {"container":"container__vcD6a","skeleton":"skeleton__ct3G6","content":"content__clHT0"};